class ElirenaCollectionTabs extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    // Theme-block settings belong to the block, so each block supplies its own header.
    const nav = this.querySelector('[role="tablist"]');
    this.querySelectorAll('template[data-elirena-tab]').forEach(template => {
      nav.append(template.content);
      template.remove();
    });
    const tabs = [...this.querySelectorAll('[role="tab"]')];
    const panels = [...this.querySelectorAll('[role="tabpanel"]')];
    const activate = (tab, focus = false, scroll = true) => {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      if (focus) tab.focus();
      if (scroll) tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab), options);
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
      }, options);
    });
    if (tabs.length) activate(tabs[0], false, false);
    this.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[role="tabpanel"]');
      const tab = tabs.find(item => item.getAttribute('aria-controls') === panel?.id);
      if (tab) activate(tab);
    }, options);
    panels.forEach(panel => {
      const rail = panel.querySelector('.elirena-tabs__products');
      panel.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
        rail.scrollBy({ left: Number(button.dataset.railStep) * rail.clientWidth, behavior: 'smooth' });
      }, options));
      rail.addEventListener('dragstart', event => event.preventDefault(), options);
      let start;
      let dragged = false;
      rail.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
        start = { x: event.clientX, scroll: rail.scrollLeft };
        dragged = false;
      }, options);
      rail.addEventListener('pointermove', event => {
        if (!start || !event.buttons) return;
        if (Math.abs(event.clientX - start.x) > 6) {
          dragged = true;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(event.pointerId);
          rail.scrollLeft = start.scroll - event.clientX + start.x;
        }
      }, options);
      const end = () => { start = null; rail.classList.remove('is-dragging'); };
      rail.addEventListener('pointerup', end, options);
      rail.addEventListener('pointercancel', end, options);
      rail.addEventListener('click', event => {
        if (dragged) { event.preventDefault(); event.stopPropagation(); dragged = false; }
      }, { ...options, capture: true });
    });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('elirena-collection-tabs')) customElements.define('elirena-collection-tabs', ElirenaCollectionTabs);
document.addEventListener('click', event => {
  const link = event.target.closest('[data-elirena-scroll]');
  if (!link) return;
  const next = link.closest('.shopify-section')?.nextElementSibling;
  if (next) { event.preventDefault(); next.scrollIntoView({ behavior: 'smooth' }); }
});
